import { Button, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import FRONTEND_ROUTES from '@/consts/frontendRoutes';

const PrivacyPolicyBtn = () => {
  const { t } = useTranslation('common');
  return (
    <Button
      component="a"
      variant="text"
      href={FRONTEND_ROUTES.PRIVACY_POLICY}
      target="_blank"
      rel="noopener noreferrer"
    >
      <Typography sx={{ textDecoration: 'underline', color: 'common.white' }}>
        {t('DASHBOARD_OTHER_LINKS.PRIVACY_POLICY')}
      </Typography>
    </Button>
  );
};

export default PrivacyPolicyBtn;
